<template>
  <div class="text">
    This is how you will get paid. We use Stripe to securely deposit money into your account.
  </div>

  <StripeConnectButton class="stripe-button-connect-wrapper" />

  <div class="skip-link-wrapper">
    <Button label="Skip for now" class="p-button-link" @click="skip" />
  </div>
</template>

<script setup>
import StripeConnectButton from "./StripeConnectButton";

const emit = defineEmits(['skip']);

const skip = () => emit('skip');
</script>

<style lang="scss" scoped>
@import '../assets/sass/theme_variables';

.stripe-button-connect-wrapper {
  margin-top: toRem(24);
}

.skip-link-wrapper {
  margin-top: toRem(16);
}

.text {
  color: $textSecondaryColor;
}
</style>
